import { render, staticRenderFns } from "./InfoBarOptionText.vue?vue&type=template&id=94513a0e&"
import script from "./InfoBarOptionText.vue?vue&type=script&lang=js&"
export * from "./InfoBarOptionText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports